import { useStyles } from '../../SystemSettings.styles';
import Checkbox from '../../../Checkbox.component';
import { FlagIcon } from './FlagIcon.component';

interface FlagProps {
  id: number;
  name: string;
  label: string;
  color: string;
  isChecked: boolean;
  onChange: () => void;
}

export const Flag: React.FC<FlagProps> = (props) => {
  const classes = useStyles();

  const Flag = (
    <div style={{display: "inline-flex"}}>
      <FlagIcon id={props.id} name={props.name} color={props.color} />
      <span className={classes.flagLabel}>{props.name}</span>
    </div>
  );

  return (
    <div className={classes.flagContainer}>
      <Checkbox
        flagLabel={Flag}
        className={classes.flagCheckbox}
        checked={props.isChecked}
        onChange={props.onChange}
      />
    </div>
  );
};
